<div class="content">
    <!-- Begin dashboard -->
    <div class="container-fluid" style="max-height: 860px;">
        <!-- Page Heading -->
        <div class="row">
            <div class="col d-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">Client Registration</h1>
            </div>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-12  d-flex align-items-center justify-content-between pb-2">
                <!-- Search Box -->
                <div class="col-lg-9 col-md-8">
                  <div class="google-search-container">

                    <i class="fa fa-search search-icon"></i>

                    <input
                      (keyup)="handleKeyUp($event)"
                      [(ngModel)]="searchText"
                      #searchBox
                      class="google-search-input"
                      type="text"
                      placeholder="Search Client..."
                    />

                    <i
                      *ngIf="searchBox.value"
                      class="fa fa-times clear-icon"
                      (click)="clearSearch(searchBox)"
                    ></i>

                  </div>
                </div>

                <!-- Filter and Add Buttons -->
                <div class="col-lg-3 col-md-4 d-flex justify-content-end">
                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchData(2)">
                            Active
                        </button>
                        <button class="btn btn-danger" (click)="_fetchData(3)"> Inactive</button>
                        <button class="btn btn-secondary active" (click)="_fetchData(1)"> All</button>
                    </div>&nbsp;&nbsp;
                    <button *ngIf="this.authService.hasRole('client-edit')" class="btn btn-primary float-right btn-add-patient" type="button" routerLink="register" title="Add Client">
                        <i class="fas fa-plus"></i>
                        <span class="btn-label">Add Client</span>
                    </button>
                </div>
            </div>

            <!-- Table -->
            <div class="col-xl-12 col-md-12 mb-2">
                    <div class="table-panel p-4">
                        <div class="table-responsive table-scroll-x">
                            <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                                <thead>
                                <tr>
                                    <th  scope="col">Sr.No</th>
                                    <th mat-sort-header="name" scope="col">Name</th>
                                    <th mat-sort-header="email" scope="col">Email</th>
                                    <th mat-sort-header="number" scope="col">Contact</th>
                                    <th mat-sort-header="active" scope="col">Status</th>
                                    <th scope="col">Upload Template</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody *ngFor="let table of tableData| filter: searchText; let i = index">
                                <tr>
                                    <th scope="row">{{i + 1}}</th>
                                  <td><a [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]: null">{{table.name ? table.name : '-'}}</a></td>
                                    <td>{{table.email ? table.email : '-'}}</td>
                                    <td>{{table.number ? table.number : '-'}}</td>
                                    <td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                                                style="color: #34ce57"></i></td>
                                    <td *ngIf="!table.active"><i class="fa-solid fa-square-check "
                                                                 style="color: #dc3545"></i></td>
                                    <!--<td>
                                        <button [routerLink]="this.authService.hasAnyRole(['client-view','client-edit']) ? ['/questionnaire', table.id]: null" class="btn btn-primary btn-sm" style="font-size: .8rem; line-height: 1.5;" >
                                            Questionnaire
                                        </button>
                                    </td>-->
                                    <td>
                                        <button class="btn btn-primary" type="button" (click)="openModal(table.id)" title="Upload Template">
                                            <i class="fa-solid fa-cloud-arrow-up"></i>
                                        </button>&nbsp;&nbsp;
                                        <button class="btn btn-info" (click)="exportViewFile( table.id, 'Template', 'view')" title="View File">
                                            <i class="fa-solid fa-eye"></i>
                                        </button>
                                            <!--<a   [href]="table.uploadedFileUrl" target="_blank"  class="btn btn-success" title="View File">
                                                <i class="fa-solid fa-eye"></i>
                                            </a>-->
                                    </td>
                                    <td>
                                        <a title="Edit"  [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id] : null"><i
                                                class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <!-- <a title="Delete" (click)="deleteEntry(table.id)" ><i class="fa-regular fa-trash-can text-danger"></i></a>&nbsp;-->
                                    </td>
                                </tr>
                                </tbody>
                                <tbody *ngIf="tableData == null || tableData.length == 0">
                                <tr>
                                    <td colspan="6" class="text-center"> No record found !</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>

<!-- Bulk Upload Modal -->
<div #templateUpload class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Upload Template</h3>
                <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form  >
                    <!-- Form content goes here -->
                    <div *ngIf="!fileImage" class="dropzone"
                         (dragover)="onDragOver($event)"
                         (dragleave)="onDragLeave($event)"
                         (drop)="onDrop($event)"
                         [ngClass]="{'is-dragover': isDragOver}">
                        <input type="file"
                               #fileDropRef
                               id="fileDropRef"
                               (change)="onFilesSelected($event)"
                               accept=".xls, .xlsx, .xlsm, .xlsb, .xltx, .xltm, .xls, .xlt, .xml, .xlr , .csv, .tsv , .txt "/>
                        <h3 *ngIf="!fileImage">Drag and drop files here</h3>
                        <label for="fileDropRef" *ngIf="!fileImage">Browse for files</label>
                    </div>
                    <div *ngIf="fileImage" class="image-container">
                        <img [src]="fileImage" alt="Uploaded File" class="uploaded-image" />
                        <button class="remove-btn" (click)="removeImage()">X</button>
                    </div>

                    <div class="row col-xl-12 pt-4 align-items-center"  *ngIf="files?.length ? files?.length > 0 : null">
                        <h4>Selected File:</h4>
                        <ul>
                            <li *ngFor="let file of files">{{ file.name }}</li>
                        </ul>
                    </div>
                </form>
            </div>
            <div *ngIf="errorMessagePart" class="error-message">
                <h4>{{ errorMessagePart }}</h4>
                <ul *ngIf="errorMessages.length > 0">
                    <li *ngFor="let error of errorMessages">
                        {{ error }}
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
                <button *ngIf="files?.length" type="button" class="btn btn-primary" (click)="uploadFiles()">Upload</button>
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
            </div>
        </div>
    </div>
</div>



<!--//working -->
<!--<div #templateUpload class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Upload Template</h3>
                <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="spreadsheet-container">
                    <form [formGroup]="spreadsheetForm" class="spreadsheet-form">
                        <div formArrayName="rows" class="spreadsheet-rows">
                            <div *ngFor="let row of rows.controls; let rowIndex = index"
                                 [formGroupName]="rowIndex" class="spreadsheet-row">
                                <div class="row-actions">
                                    <button mat-icon-button color="warn" (click)="removeRow(rowIndex)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    <button mat-icon-button color="primary" (click)="addColumn(row)">
                                        <mat-icon>add_box</mat-icon>
                                    </button>
                                </div>

                                <div formArrayName="columns" class="spreadsheet-columns">
                                    <div *ngFor="let column of getColumns(row).controls; let colIndex = index"
                                         [formGroupName]="colIndex" class="spreadsheet-column">
                                        <div class="column-actions">
                                            <button mat-icon-button color="warn" (click)="removeColumn(row, colIndex)">
                                                <mat-icon>delete_sweep</mat-icon>
                                            </button>
                                            <button mat-icon-button color="primary" (click)="addCell(column)">
                                                <mat-icon>add</mat-icon>
                                            </button>
                                        </div>

                                        <div formArrayName="cells" class="spreadsheet-cells">
                                            <mat-form-field
                                                    *ngFor="let cell of getCells(column).controls; let cellIndex = index"
                                                    [formGroupName]="cellIndex" class="spreadsheet-cell">
                                                <input matInput
                                                       [formControlName]="'value'"
                                                       placeholder="Cell {{rowIndex}}-{{colIndex}}-{{cellIndex}}">
                                                <button mat-icon-button matSuffix color="warn"
                                                        (click)="removeCell(column, cellIndex)">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="actions">
                        <button mat-raised-button color="primary" (click)="addRow()">Add Row</button>
                    </div>
                </div>

                <div class="text-right mt-3">
                    <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>-->

<!--<div class="spreadsheet-wrapper">
    <div #templateUpload class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Upload Template</h3>
                    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="spreadsheet-container">
                        <form [formGroup]="spreadsheetForm" class="spreadsheet-form" (ngSubmit)="onSubmit()">
                            <div formArrayName="rows" class="spreadsheet-rows">
                                <div *ngFor="let row of rows.controls; let rowIndex = index"
                                     [formGroupName]="rowIndex"
                                     class="spreadsheet-row"
                                     [class.invalid]="!isRowValid(row) && row.touched">

                                    &lt;!&ndash; Row Header &ndash;&gt;
                                    <div class="row-header">
                                        <mat-form-field class="row-header-input">
                                            <mat-label>Row Header</mat-label>
                                            <input matInput
                                                   [formControlName]="'header'"
                                                   placeholder="Enter header">
                                            &lt;!&ndash;<mat-error *ngIf="row.get('header')?.errors?.required">
                                                Header is required
                                            </mat-error>&ndash;&gt;
                                        </mat-form-field>
                                    </div>

                                    &lt;!&ndash; Row Actions &ndash;&gt;
                                    <div class="row-actions">
                                        <button type="button"
                                                mat-icon-button
                                                color="warn"
                                                [disabled]="rows.length === 1"
                                                (click)="removeRow(rowIndex)"
                                                matTooltip="Delete Row">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                        <button type="button"
                                                mat-icon-button
                                                color="primary"
                                                (click)="addColumn(row)"
                                                matTooltip="Add Column">
                                            <mat-icon>add_box</mat-icon>
                                        </button>
                                    </div>

                                    &lt;!&ndash; Columns &ndash;&gt;
                                    <div formArrayName="columns" class="spreadsheet-columns">
                                        <div *ngFor="let column of getColumns(row).controls; let colIndex = index"
                                             [formGroupName]="colIndex"
                                             class="spreadsheet-column"
                                             [class.invalid]="!isColumnValid(column) && column.touched">

                                            &lt;!&ndash; Column Actions &ndash;&gt;
                                            <div class="column-actions">
                                                <button type="button"
                                                        mat-icon-button
                                                        color="warn"
                                                        [disabled]="getColumns(row).length === 1"
                                                        (click)="removeColumn(row, colIndex)"
                                                        matTooltip="Delete Column">
                                                    <mat-icon>delete_sweep</mat-icon>
                                                </button>
                                                <button type="button"
                                                        mat-icon-button
                                                        color="primary"
                                                        (click)="addCell(column)"
                                                        matTooltip="Add Cell">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>

                                            &lt;!&ndash; Cells &ndash;&gt;
                                            <div formArrayName="cells" class="spreadsheet-cells">
                                                <mat-form-field *ngFor="let cell of getCells(column).controls; let cellIndex = index"
                                                                [formGroupName]="cellIndex"
                                                                class="spreadsheet-cell"
                                                                appearance="outline">
                                                    <mat-label>Cell Value</mat-label>
                                                    <input matInput
                                                           [formControlName]="'value'"
                                                           [placeholder]="'Cell ' + (rowIndex + 1) + '-' + (colIndex + 1) + '-' + (cellIndex + 1)">
                                                    <button type="button"
                                                            mat-icon-button
                                                            matSuffix
                                                            color="warn"
                                                            [disabled]="getCells(column).length === 1"
                                                            (click)="removeCell(column, cellIndex)"
                                                            matTooltip="Delete Cell">
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                    &lt;!&ndash;<mat-error *ngIf="cell.get('value')?.errors?.required">
                                                        Value is required
                                                    </mat-error>&ndash;&gt;
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            &lt;!&ndash; Form Actions &ndash;&gt;
                            <div class="form-actions">
                                <button type="button"
                                        mat-raised-button
                                        color="primary"
                                        (click)="addRow()"
                                        class="action-button">
                                    <mat-icon>add</mat-icon>
                                    Add Row
                                </button>

                                <button type="button"
                                        mat-raised-button
                                        color="warn"
                                        (click)="resetForm()"
                                        class="action-button">
                                    <mat-icon>refresh</mat-icon>
                                    Reset Form
                                </button>
                            </div>

                            &lt;!&ndash; Submit/Cancel Actions &ndash;&gt;
                            <div class="modal-actions">
                                <button type="button"
                                        mat-button
                                        (click)="closeModal()"
                                        class="action-button">
                                    Cancel
                                </button>
                                <button type="submit"
                                        mat-raised-button
                                        color="primary"
                                        [disabled]="!spreadsheetForm.valid"
                                        class="action-button">
                                    Save Template
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>-->
